import { useDisclosure } from "@chakra-ui/hooks";
import { Modal, ModalBody, ModalContent, ModalOverlay, ModalHeader, ModalFooter } from "@chakra-ui/modal";
import { getClient, createClient, updateClientById } from "api/graphQL_clients";
import { getAllOrganizationsSecond, getOrganization } from "api/graphQL_organizations";
import DivLoader from "components/divloader/DivLoader";
import InputField from "components/fields/InputField";
import TextArea from "components/fields/TextArea";
import ClientPayment from "./ClientPayment";
import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { MdEdit, MdHighlightOff, MdInfo } from "react-icons/md";
import { Select as AntSelect } from "antd";
import _ from "lodash";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

interface iCreateOrgForm {
  name: string; org_id: string; description?: string; website?: string;
  email?: string; phone?: string; address?: string; city?: string;
  state?: string; country?: string; postal_code?: string; assigned_payment_methods?: string;
}
interface Organization { id: string; name: string; description: string; payment_methods: string[]; }

const CreateClientModal = ({
  fetchClients, id, info, roleData, allGateways, infoData,
}: {
  fetchClients: () => void; id?: string; info?: boolean;
  roleData?: any; allGateways?: any; infoData?: any;
}) => {
  const rootForm: iCreateOrgForm = {
    name: "", org_id: "", description: "", website: "", email: "",
    phone: "", address: "", city: "", state: "", country: "", postal_code: "", assigned_payment_methods: "",
  };

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [formValues, setFormValues] = React.useState<iCreateOrgForm>(rootForm);
  const [initialValues, setInitialFormValues] = React.useState<iCreateOrgForm>(rootForm);
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [allorganizations, setallOrganizations] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [viewMode, setViewMode] = React.useState<boolean>(info);
  const [org, setOrg] = React.useState<any>();
  const [orgID, setOrgID] = React.useState<any>();
  const [paymentMethods, setPaymentMethods] = React.useState([]);
  const [checkedpaymentMethods, setCheckedPaymentMethods] = React.useState([]);
  const [multiselectError, setMultiselectError] = useState<boolean>(false);
  const [formValuesErr, setFormValuesErr] = React.useState<iCreateOrgForm>(rootForm);
  const [methodName, setMethodName] = useState<boolean>(false);
  const [isCloseModal, setIsCloseModal] = React.useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const fetchOrganizations = () => {
    setIsLoading(true);
    getAllOrganizationsSecond(1, 500, "")
      .then((data) => {
        setOrganizations(data?.[0]?.map((ele: any) => ({ name: ele.name, id: ele.id })));
        setallOrganizations(data);
      })
      .catch((err) => toast.error(err?.response?.data?.message ?? "Error fetching organizations"))
      .finally(() => setIsLoading(false));
  };

  function fetchClient() {
    getClient(id)
      .then((data: any) => {
        setFormValues(data[0]); setInitialFormValues(data[0]); setOrgID(data[0].org_id);
        const selected = data[0]?.assigned_payment_methods.map((ele: any) => {
          const gateway = allGateways?.find((item: any) => item.id === ele);
          return { value: ele, label: methodName ? gateway?.name : ele };
        });
        setCheckedPaymentMethods(selected);
        setMultiselectError(data[0]?.assigned_payment_methods?.length > 0);
      })
      .catch((err: any) => toast.error(err?.response?.data?.message ?? "Unable to fetch data"));
  }

  React.useEffect(() => {
    if (orgID !== undefined) {
      setMethodName(roleData[0]?.client?.value?.client_show_method_name);
      getOrganization({ id: orgID })
        .then((data: any) => setPaymentMethods(data[0]?.payment_methods))
        .catch((err: any) => toast.error(err?.response?.data?.message ?? "Unable to fetch data"));
    }
  }, [orgID]);

  const handleClose = () => {
    setIsSubmitted(false);
    setFormValues(rootForm); setFormValuesErr(rootForm);
    setIsCloseModal(true);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 300);
  };

  function handleChildSelectionChange(selected: any) {
    setFormValues((p: any) => ({ ...p, assigned_payment_methods: selected?.map((e: any) => e.value) }));
    // setMultiselectError(selected?.length > 0);
    setMultiselectError(selected?.length ? true : false);
  }

  function handleValueChange(e: any) {
    setMethodName(roleData[0]?.client?.value?.client_show_method_name);
    const { id: fid, value } = e.target;
    const websiteRx = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/;
    const emailRx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const phoneRx = /^\d+$/;
    let err = "";
    if (fid === "website" && value && !websiteRx.test(value)) err = "Invalid website URL";
    if (fid === "email" && value && !emailRx.test(value)) err = "Invalid email address";
    if (fid === "phone" && value && !phoneRx.test(value)) err = "Invalid phone number";
    setFormValuesErr((p: any) => ({ ...p, [fid]: err }));
    setFormValues((p: any) => ({ ...p, [fid]: value }));
  }

  function validateData() {
    let v: any = {};
    if (!formValues?.name) v.name = "The field is required";
    if (!formValues?.org_id) v.org_id = "The field is required";
    const websiteRx = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d{1,5})?(\/.*)?$/;
    const emailRx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (formValues.website && !websiteRx.test(formValues.website)) v.website = "Invalid website URL";
    if (formValues.email && !emailRx.test(formValues.email)) v.email = "Invalid email address";
    // if (!formValues?.assigned_payment_methods?.length) { v.assigned_payment_methods = "The field is required"; setMultiselectError(false); }
    // else setMultiselectError(true);
    if (!formValues?.assigned_payment_methods?.length) {
      v.assigned_payment_methods = "The field is required";
    }
    if (Object.keys(v).length) { setFormValuesErr(v); return false; }
    return true;
  }

  async function handleSubmit(e: any) {
    e.preventDefault();
    setIsSubmitted(true);
    if (!validateData()) return;
    try {
      setIsLoading(true);
      if (id) {
        // if (!_.isEqual(formValues, initialValues)) {
        //   toast.error("No changes detected.");
        //   handleClose(); return;
        // }
        const update = await updateClientById(formValues);
        if (update.errors) toast.error(update.errors[0].message);
        else if (update[0].status === "Success") { toast.success("Client updated successfully"); fetchClients(); handleClose(); }
        else toast.error(update[0].message ?? "Something went wrong");
      } else {
        const create = await createClient(formValues);
        if (create.errors) toast.error(create.errors[0].message);
        else if (create[0].status === "Success") { toast.success("Client created successfully"); fetchClients(); handleClose(); }
        else toast.error(create[0].message ?? "Something went wrong");
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message ?? "Operation failed");
    } finally {
      setIsLoading(false);
    }
  }

  const hasFormChanged = () => Object.keys(formValues).some((k) => formValues[k as keyof iCreateOrgForm] !== initialValues[k as keyof iCreateOrgForm]);

  /* ── Trigger button / icon ── */
  const TriggerEl = () => {
    if (info) {
      if (!roleData?.[0]?.client?.value?.view_client) return null;
      return (
        <Popover trigger="hover" placement="bottom">
          <PopoverTrigger>
            <div onClick={() => { if (id) fetchClient(); fetchOrganizations(); setViewMode(true); onOpen(); }}>
              <div className="ccm-action-icon ccm-action-icon--blue" title="View">
                <MdInfo size={16} />
              </div>
            </div>
          </PopoverTrigger>
          <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" boxShadow="0 8px 24px rgba(15,23,42,0.08)" bg="#eff6ff" maxW="260px" p="0" overflow="hidden" zIndex="20">
            <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="14px" py="10px">View Client Details</PopoverHeader>
            <PopoverArrow bg="#eff6ff" />
          </PopoverContent>
        </Popover>
      );
    }
    if (id) {
      if (!roleData?.[0]?.client?.value?.edit_client) return null;
      return (
        <Popover trigger="hover" placement="bottom">
          <PopoverTrigger>
            <div onClick={() => { if (id) fetchClient(); fetchOrganizations(); onOpen(); }}>
              <div className="ccm-action-icon ccm-action-icon--amber">
                <MdEdit size={16} />
              </div>
            </div>
          </PopoverTrigger>
          <PopoverContent border="1px solid #fde68a" borderRadius="12px" boxShadow="0 8px 24px rgba(15,23,42,0.08)" bg="#fffbeb" maxW="260px" p="0" overflow="hidden" zIndex="20">
            <PopoverHeader bg="#fef3c7" fontSize="12px" fontWeight="700" color="#92400e" borderBottom="1px solid #fde68a" px="14px" py="10px">Edit Client</PopoverHeader>
            <PopoverArrow bg="#fffbeb" />
          </PopoverContent>
        </Popover>
      );
    }
    if (!roleData?.[0]?.client?.value?.add_client) return null;
    return (
      <button className="ccm-add-btn" onClick={() => { onOpen(); fetchOrganizations(); }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
        </svg>
        Add New Client
      </button>
    );
  };

  return (
    <>
      <TriggerEl />

      <Modal isOpen={isOpen} onClose={() => {}}>
        <ModalOverlay className="bg-[#000] !opacity-40" />
        <div className={`ccm-panel${isOpen && !isCloseModal ? " ccm-panel--open" : " ccm-panel--close"}`}>

          {/* Panel header */}
          <div className="ccm-panel-header">
            <div className="ccm-panel-header-left">
              <div className={`ccm-panel-icon${viewMode ? " ccm-panel-icon--view" : id ? " ccm-panel-icon--edit" : " ccm-panel-icon--create"}`}>
                {viewMode ? <MdInfo size={18} /> : id ? <MdEdit size={18} /> : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                  </svg>
                )}
              </div>
              <div>
                <h2 className="ccm-panel-title">
                  {viewMode ? "Client Details" : id ? `Edit — ${infoData?.row?.original?.name ?? "Client"}` : "Create New Client"}
                </h2>
                <p className="ccm-panel-sub">
                  {viewMode ? "View client information" : id ? "Update client details below" : "Fill in the details to add a client"}
                </p>
              </div>
            </div>
            <div className="ccm-panel-header-right">
              {viewMode && roleData?.[0]?.client?.value?.edit_client && (
                <button className="ccm-edit-mode-btn" onClick={() => setViewMode(false)}>
                  <MdEdit size={14} /> Edit
                </button>
              )}
              <button className="ccm-close-btn" onClick={handleClose} aria-label="Close">
                <MdHighlightOff size={22} />
              </button>
            </div>
          </div>

          {/* Panel body */}
          <div className="ccm-panel-body">

            {/* Section: Basic info */}
            <div className="ccm-section">
              <div className="ccm-section-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="7" r="4"/><path d="M5.5 21h13"/></svg>
                Basic Information
              </div>
              <div className="ccm-row-2">
                <div className="ccm-field">
                  <label className="ccm-label">Organization <span className="ccm-required">*</span></label>
                  <AntSelect
                    showSearch filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                    allowClear placeholder="Select organization"
                    className="ccm-ant-select" disabled={viewMode}
                    options={organizations?.map((m: any) => ({ ...m, label: m?.name, value: m?.id }))}
                    value={formValues?.org_id || undefined}
                    onChange={(e: any) => {
                      setFormValues((p: any) => ({ ...p, org_id: e }));
                      setFormValuesErr((p: any) => ({ ...p, org_id: "" }));
                    }}
                    notFoundContent="No organizations found"
                  />
                  {formValuesErr?.org_id && <p className="text-sm text-orange-500">{formValuesErr.org_id}</p>}
                </div>
                <div className="ccm-field">
                  <InputField variant="auth" extra="mb-0 w-full" placeholder="Google Inc." id="name" label="Client Name *"
                    type="text" disabled={viewMode} value={formValues?.name} onChange={handleValueChange}
                    errMessage={formValuesErr?.name || ""} />
                </div>
              </div>
            </div>

            {/* Section: Contact */}
            <div className="ccm-section">
              <div className="ccm-section-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                Contact Details
              </div>
              <div className="ccm-row-2">
                <InputField variant="auth" extra="mb-0 w-full" label="Website" placeholder="www.example.com"
                  id="website" type="text" disabled={viewMode} value={formValues?.website}
                  onChange={handleValueChange} errMessage={formValuesErr?.website || ""} />
                <InputField variant="auth" extra="mb-0 w-full" label="Email" placeholder="contact@company.com"
                  id="email" type="text" disabled={viewMode} value={formValues?.email}
                  onChange={handleValueChange} errMessage={formValuesErr?.email || ""} />
              </div>
              <div className="ccm-field mt-1">
                <label className="ccm-label">Phone</label>
                <PhoneInput country="" disabled={viewMode} value={formValues?.phone}
                  onChange={(value) => setFormValues((p: any) => ({ ...p, phone: value }))}
                  inputStyle={{ width: "100%", height: "46px", fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: "14px", border: "1.5px solid #e2e8f0", borderRadius: "10px", background: viewMode ? "#f8fafc" : "#ffffff" }}
                  buttonStyle={{ border: "1.5px solid #e2e8f0", borderRadius: "10px 0 0 10px", background: "#f8fafc" }}
                  inputProps={{ id: "phone" }}
                />
                {formValuesErr?.phone && <p className="text-sm text-orange-500">{formValuesErr.phone}</p>}
              </div>
            </div>

            {/* Section: Address */}
            <div className="ccm-section">
              <div className="ccm-section-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
                Address
              </div>
              <InputField variant="auth" extra="mb-0 w-full" label="Address Line" placeholder="45 Test Street"
                id="address" type="text" disabled={viewMode} value={formValues?.address}
                state={formValuesErr?.address ? "error" : ""} onChange={handleValueChange} />
              <div className="ccm-row-2 ccm-row-2--mt">
                <InputField variant="auth" extra="mb-0 w-full" label="City" placeholder="Mountain View"
                  id="city" type="text" disabled={viewMode} value={formValues?.city}
                  state={formValuesErr?.city ? "error" : ""} onChange={handleValueChange} />
                <InputField variant="auth" extra="mb-0 w-full" label="State" placeholder="California"
                  id="state" type="text" disabled={viewMode} value={formValues?.state}
                  state={formValuesErr?.state ? "error" : ""} onChange={handleValueChange} />
              </div>
              <div className="ccm-row-2 ccm-row-2--mt">
                <InputField variant="auth" extra="mb-0 w-full" label="Country" placeholder="USA"
                  id="country" type="text" disabled={viewMode} value={formValues?.country}
                  state={formValuesErr?.country ? "error" : ""} onChange={handleValueChange} />
                <InputField variant="auth" extra="mb-0 w-full" label="Postal Code" placeholder="850125"
                  id="postal_code" type="text" disabled={viewMode} value={formValues?.postal_code}
                  state={formValuesErr?.postal_code ? "error" : ""} onChange={handleValueChange} />
              </div>
            </div>

            {/* Section: Description */}
            <div className="ccm-section">
              <div className="ccm-section-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="21" y1="6" x2="3" y2="6"/><line x1="15" y1="12" x2="3" y2="12"/><line x1="17" y1="18" x2="3" y2="18"/></svg>
                Description
              </div>
              <TextArea variant="auth" extra="mb-0 w-full" label="" placeholder="Add a description…"
                height="80px" id="description" disabled={viewMode} value={formValues?.description}
                state={formValuesErr?.description ? "error" : ""} onChange={handleValueChange} />
            </div>

            {/* Section: Payment methods */}
            <div className="ccm-section ccm-section--last">
              <div className="ccm-section-label">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                Payment Methods <span className="ccm-required">*</span>
              </div>
              <ClientPayment
                Organization={paymentMethods} slectedOrg={org}
                assignPaymentMethod={checkedpaymentMethods}
                handleSelectionChange={handleChildSelectionChange}
                errorclass={isSubmitted && !formValues?.assigned_payment_methods?.length} 
                methodName={methodName}
                viewMode={viewMode} allGateways={allGateways} formData={formValues}
              />
            </div>
          </div>

          {/* Panel footer */}
          <div className="ccm-panel-footer">
            <div className="ccm-footer-note">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
              <span>All data is encrypted and secure</span>
            </div>
            <div className="ccm-footer-btns">
              <button className="ccm-btn-cancel" onClick={handleClose}>Cancel</button>
              {!viewMode && (
                <button
                  className="ccm-btn-submit"
                  onClick={handleSubmit}
                  disabled={viewMode || !!isLoading || !hasFormChanged()}
                >
                  {isLoading ? <span className="ccm-spinner" /> : (
                    <>
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      {id ? "Update Client" : "Create Client"}
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        /* ── Trigger action icons ── */
        .ccm-action-icon {
          width: 32px; height: 32px; border-radius: 8px;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer; transition: all 0.15s; border: 1.5px solid;
        }
        .ccm-action-icon--blue { background: #eff6ff; border-color: #bfdbfe; color: #2563eb; }
        .ccm-action-icon--blue:hover { background: #dbeafe; border-color: #93c5fd; }
        .ccm-action-icon--amber { background: #fffbeb; border-color: #fde68a; color: #d97706; }
        .ccm-action-icon--amber:hover { background: #fef3c7; border-color: #fcd34d; }

        .ccm-add-btn {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          cursor: pointer;
          box-shadow: 0 3px 12px rgba(37,99,235,0.3);
          transition: transform 0.15s, box-shadow 0.18s;
        }
        .ccm-add-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(37,99,235,0.38); }

        /* ── Slide-over panel ── */
        .ccm-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 600px;
          background: #ffffff;
          z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -8px 0 40px rgba(15,23,42,0.15);
          transition: transform 0.32s cubic-bezier(0.16,1,0.3,1);
        }
        .ccm-panel--open  { transform: translateX(0); }
        .ccm-panel--close { transform: translateX(100%); }

        /* Panel header */
        .ccm-panel-header {
          display: flex; align-items: center; justify-content: space-between;
          padding: 20px 28px;
          background: linear-gradient(135deg, #0f2744, #1d4ed8);
          flex-shrink: 0;
        }
        .ccm-panel-header-left { display: flex; align-items: center; gap: 14px; }
        .ccm-panel-icon {
          width: 42px; height: 42px; border-radius: 11px;
          display: flex; align-items: center; justify-content: center; flex-shrink: 0;
        }
        .ccm-panel-icon--create { background: rgba(255,255,255,0.2); color: #fff; border: 1.5px solid rgba(255,255,255,0.3); }
        .ccm-panel-icon--edit   { background: rgba(253,230,138,0.2); color: #fde68a; border: 1.5px solid rgba(253,230,138,0.3); }
        .ccm-panel-icon--view   { background: rgba(167,243,208,0.2); color: #6ee7b7; border: 1.5px solid rgba(167,243,208,0.3); }
        .ccm-panel-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -0.3px; margin-bottom: 2px;line-height:22px }
        .ccm-panel-sub { font-size: 12.5px; color: rgba(255,255,255,0.6); font-weight: 500; }
        .ccm-panel-header-right { display: flex; align-items: center; gap: 10px; }
        .ccm-edit-mode-btn {
          display: inline-flex; align-items: center; gap: 5px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 12.5px; font-weight: 700; color: #fff;
          background: rgba(255,255,255,0.15); border: 1.5px solid rgba(255,255,255,0.25);
          border-radius: 8px; padding: 7px 12px; cursor: pointer;
          transition: background 0.15s;
        }
        .ccm-edit-mode-btn:hover { background: rgba(255,255,255,0.25); }
        .ccm-close-btn {
          background: none; border: none; cursor: pointer;
          color: rgba(255,255,255,0.7); display: flex; align-items: center;
          transition: color 0.15s; padding: 2px;
        }
        .ccm-close-btn:hover { color: #fff; }

        /* Panel body */
        .ccm-panel-body { flex: 1; overflow-y: auto; padding: 0; }
        .ccm-panel-body::-webkit-scrollbar { width: 4px; }
        .ccm-panel-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* Sections */
        .ccm-section {
          padding: 20px 28px;
          border-bottom: 1px solid #f1f5f9;
        }
        .ccm-section--last { border-bottom: none; }
        .ccm-section-label {
          display: flex; align-items: center; gap: 7px;
          font-size: 11.5px; font-weight: 700; color: #1b2559;
          text-transform: uppercase; letter-spacing: 0.5px;
          margin-bottom: 14px;
        }

        .ccm-row-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
        .ccm-row-2--mt { margin-top: 12px; }
        .ccm-field { display: flex; flex-direction: column; gap: 6px; }
        .ccm-label { font-size: 13px; font-weight: 600; color: #1b2559; }
        .ccm-required { color: #dc2626; }
        .ccm-err { font-size: 12px; color: #dc2626; font-weight: 500; margin-top: 3px; }

        .ccm-ant-select { height: 46px !important; width: 100% !important; font-family: 'Plus Jakarta Sans', sans-serif !important; }

        /* Panel footer */
        .ccm-panel-footer {
          padding: 16px 28px;
          border-top: 1px solid #f1f5f9;
          background: #fafbfc;
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 12px; flex-shrink: 0;
        }
        .ccm-footer-note {
          display: flex; align-items: center; gap: 6px;
          font-size: 12px; color: #94a3b8; font-weight: 500;
        }
        .ccm-footer-btns { display: flex; gap: 10px; align-items: center; }
        .ccm-btn-cancel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 600; color: #64748b;
          padding: 10px 20px; border-radius: 10px;
          border: 1.5px solid #e2e8f0; background: #fff;
          cursor: pointer; transition: all 0.15s;
        }
        .ccm-btn-cancel:hover { background: #f1f5f9; border-color: #cbd5e1; color: #1b2559; }
        .ccm-btn-submit {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif;
          font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 22px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(37,99,235,0.3);
          transition: transform 0.15s, box-shadow 0.18s, opacity 0.18s;
          position: relative; overflow: hidden;
        }
        .ccm-btn-submit::after { content:''; position:absolute;inset:0;background:linear-gradient(135deg,rgba(255,255,255,0.1),transparent 60%); }
        .ccm-btn-submit:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(37,99,235,0.38); }
        .ccm-btn-submit:disabled { opacity: 0.55; cursor: not-allowed; transform: none; }
        .ccm-spinner {
          display: inline-block; width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.35); border-top-color: #fff;
          border-radius: 50%; animation: ccmSpin 0.65s linear infinite;
        }
        @keyframes ccmSpin { to { transform: rotate(360deg); } }

        /* Mobile */
        @media (max-width: 640px) {
          .ccm-panel { max-width: 100%; }
          .ccm-panel-header { padding: 16px 20px; }
          .ccm-section { padding: 18px 20px; }
          .ccm-panel-footer { padding: 14px 20px; }
          .ccm-row-2 { grid-template-columns: 1fr; gap: 10px; }
        }
      `}</style>
    </>
  );
};

export default CreateClientModal;